/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'damage': {
    width: 146,
    height: 243,
    viewBox: '0 0 146 243',
    data: '<path pid="0" d="M146 109.35a10.839 10.839 0 00-.09-1.507l-12.17-97.2A12.154 12.154 0 00121.67 0H24.33a12.161 12.161 0 00-12.07 10.643l-12.17 97.2A10.839 10.839 0 000 109.35a73 73 0 0060.83 71.8v37.55h-36.5V243h97.34v-24.3h-36.5v-37.547A73 73 0 00146 109.35zm-121.65.712L35.07 24.3h27.36L50.71 41.86a12.124 12.124 0 001.52 15.324L67.96 72.9 52.23 88.61l17.21 17.174 24.33-24.3a12.13 12.13 0 000-17.174L76.49 47.057 91.68 24.3h19.25l10.74 85.762a48.666 48.666 0 01-97.32 0z" fill-rule="evenodd"/>'
  }
})
